import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class names into a single string, filtering out falsy values.
 * Uses tailwind-merge to handle conflicting Tailwind CSS classes.
 *
 * @param {...string} classes - Any number of class name strings to be combined.
 * @returns {string} A single string of combined class names.
 */
export function classNames(...classes: (string | undefined | null)[]): string {
  return twMerge(...classes.filter(Boolean));
}

export const cn = classNames;
